import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

type HealthcareProviderNameInputProps = FieldControllerProps<'name', string | null> & ClassNameProp;

export const HealthcareProviderNameInput = (props: HealthcareProviderNameInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
      maxLength: 255,
   });

   return (
      <TextInput
         testId={props.name}
         label={commonTranslationKeys.name}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
